<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="title">Clip Details</span>
        <v-spacer/>
        <v-icon v-if="minimizable" @click="minimize">minimize</v-icon>
      </v-card-title>
      <v-card-text style="max-height: 417px; overflow: scroll;">
        <v-container class="pa-0">
          <v-layout row>
            <v-flex xs5 class="ma-auto text-xs-center">
              <img 
                v-if="croppedImage.url" 
                style="max-width: 300px;" 
                :src="croppedImage.url" 
              />
              <a
                v-if="download"
                class="caption" 
                @click="() => downloadScreenshot(croppedImage.url)"
              >Download this image</a>
            </v-flex>
            <v-divider vertical />
            <v-flex xs7>
              <v-form ref="reportForm">
                <v-container grid-list-xs>
                  <v-layout column>
                    <v-flex xs12>
                      <v-select
                        v-model="report.reportID"
                        label="Report Name"
                        :items="reports"
                        item-text="name"
                        item-value="uuid"
                        data-vv-name="name"
                        v-validate="'required'"
                        :error-messages="errors.collect('name')"
                      ></v-select>
                    </v-flex>
                    <v-flex>
                      <v-layout row>
                        <v-flex xs6>
                          <v-text-field
                            label="Media"
                            disabled
                            :value="page ? page.media : ''"
                            class="mr-1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            label="Page No"
                            disabled
                            :value="page ? page.pageNo : ''"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex>
                      <v-select
                        :value="page ? page.keywords : []"
                        :items="page ? page.keywords : []"
                        chips
                        attach
                        small-chips
                        label="Keywords"
                        multiple
                        disabled
                      ></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field 
                        label="Publish Date" 
                        disabled
                        :value="journalPublishDate"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field 
                        v-model="report.headline"
                        label="Headline"
                        data-vv-name="headline"
                        v-validate="'required'"
                        :error-messages="errors.collect('headline')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea 
                        v-model="report.summary"
                        label="Summary" 
                        no-resize 
                        rows="5"
                        data-vv-name="summary"
                        v-validate="'required'"
                        :error-messages="errors.collect('summary')"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row>
                        <v-flex xs6>
                          <v-select
                            v-model="report.tone"
                            label="Tone"
                            :items="['Positive', 'Negative', 'Neutral']"
                            class="mr-1"
                          ></v-select>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="report.prValue"
                            type="number"
                            label="PR Value"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="report.author"
                        label="Author"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" flat @click="cancelReport">Cancel</v-btn>
        <v-btn color="primary" flat @click="saveReport">OK</v-btn>
      </v-card-actions>
    </v-card>  
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import moment from "moment";
import axios from "axios";
import { forceDownload } from "../utils/file.utils";

Vue.use(VeeValidate);

const defaultReport = {
  reportID: "",
  headline: "",
  summary: "",
  tone: "",
  prValue: "",
  author: "",
};

export default {
  name: "ClipForm",

  $_veeValidate: {
    validator: "new",
  },

  props: [
    "croppedImage",
    "reports",
    "page",
    "editClip",
    "download",
    "minimizable",
  ],

  data() {
    return {
      report: {
        reportID: "",
        headline: "",
        summary: "",
        tone: "",
        prValue: "",
        author: "",
      },

      dictionary: {
        custom: {
          name: {
            required: () => "Report name is required.",
          },
          headline: {
            required: () => "Headline is required.",
          },
          summary: {
            required: () => "Summary is required.",
          }
        }
      },
    };
  },

  mounted() {
    this.$validator.localize("en", this.dictionary);
  },

  methods: {
    minimize() {
      this.$emit("minimize");
    },

    cancelReport() {
      const msg = `Are you sure you want to cancel? Your${this.editClip ? " updated " : " "}data will be lost.`
      if (confirm(msg)) {
        this.$validator.reset();
        this.$emit("cancel");

        Object.assign(this.report, defaultReport);
      }
    },

    saveReport() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          const report = Object.assign({}, this.report);
          this.$emit("save", report);

          Object.assign(this.report, defaultReport);
          this.$validator.reset();
        }
      });
    },

    downloadScreenshot(imgUrl) {
      axios({
        method: 'get',
        url: imgUrl,
        responseType: 'arraybuffer',
      })
      .then(res => forceDownload(res, imgUrl));
    },
  },

  computed: {
    journalPublishDate() {
      return this.page ? moment(this.page.publishDate).format('LL') : "";
    },
  },

  watch: {
    editClip(val) {
      if (val) {
        this.report = Object.assign({}, val);
      }
    }
  }
}
</script>

<style scoped>

</style>